export abstract class ChatConstants {
  static readonly MAX_WAIT_TIME_MS = 10000;
}
